import React, {useEffect, useRef} from 'react';
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {
    $getRoot,
    $getSelection,
    $isRangeSelection,
    $setSelection,
    COMMAND_PRIORITY_LOW,
    SELECTION_CHANGE_COMMAND
} from "lexical";
import EmojiPicker from "../../EmojiPicker";
import {isRTL} from "../../../../services/i18n";

const EmojiPickerPlugin = () => {
    const [editor] = useLexicalComposerContext();
    const lastRangeSelectionRef = useRef(null);

    useEffect(() => {
        return editor.registerCommand(
            SELECTION_CHANGE_COMMAND,
            () => {
                editor.getEditorState().read(() => {
                    const selection = $getSelection();
                    if ($isRangeSelection(selection)) {
                        lastRangeSelectionRef.current = selection.clone();
                    }
                });
                return false;
            },
            COMMAND_PRIORITY_LOW
        );
    }, [editor]);

    const onEmojiClick = (emoji) => {
        const emojiChar = emoji?.native;
        if (!emojiChar) return;

        editor.focus();

        editor.update(() => {
            if (lastRangeSelectionRef.current) {
                $setSelection(lastRangeSelectionRef.current.clone());
            }

            let selection = $getSelection();

            if (!$isRangeSelection(selection)) {
                $getRoot().selectEnd();
                selection = $getSelection();
            }

            if ($isRangeSelection(selection)) {
                selection.insertText(emojiChar);
                lastRangeSelectionRef.current = selection.clone();
            }
        });
    };

    return (
        <div onMouseDown={(e) => e.preventDefault()}
             style={{position: 'absolute', bottom: '10px', [isRTL() ? 'left' : 'right']: '10px', zIndex: 2}}>
            <EmojiPicker onEmojiClick={onEmojiClick}/>
        </div>
    );
};

export default EmojiPickerPlugin;
